import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2),
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#000',
    marginBottom: theme.spacing(3),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  instructionText: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    color: '#333',
  },
  formContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #E0E0E0',
    marginBottom: theme.spacing(3),
  },
  formControl: {
    minWidth: '300px',
  },
  textField: {
    width: '100%',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: theme.spacing(1),
    color: '#333',
    display: 'block',
  },
  required: {
    color: 'red',
  },
  viewReportButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '2rem',
    padding: '6px 12px',
    height: '32px',
    '&:hover': {
      backgroundColor: '#000000',
    },
  },
  reportTitle: {
    fontSize: '20px',
    fontWeight: 600,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  summaryTableWrapper: {
    padding: '15px',
    display: 'inline-block',
    marginBottom: theme.spacing(3),
    width: '75%',
  },
  summaryTable: {
    width: '100%',
    '& .MuiTableCell-root': {
      border: 'none',
      padding: '10px 16px',
      textAlign: 'center',
    },
  },
  summaryHeader: {
    fontSize: '0.875rem',
    color: '#000',
    fontWeight: 600,
    backgroundColor: '#E5F2F7',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  summaryRow: {
    '& > td': {
      borderBottom: 'none',
    },
  },
  summaryCell: {
    fontSize: '0.875rem',
    color: '#000',
    fontWeight: 400,
    backgroundColor: '#E5F2F7',
    textAlign: 'center',
  },
  statusButton: {
    backgroundColor: '#4CAF50',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '4px',
    padding: '4px 12px',
    fontSize: '12px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#45a049',
    },
  },
  downloadButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '2rem',
    padding: '4px 12px',
    fontSize: '0.75rem',
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: '#000000',
    },
  },
  summaryContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(3),
    gap: theme.spacing(2),
  },
  legendContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    flexShrink: 0,
    alignSelf: 'center',
    paddingBottom: 0,
    marginBottom: 0,
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginBottom: 0,
    paddingBottom: 0,
    '&:last-child': {
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
  legendSquare: {
    width: '16px',
    height: '16px',
    borderRadius: '2px',
  },
  legendCMO: {
    backgroundColor: '#ec6535',
  },
  legendSponsor: {
    backgroundColor: '#712B5D',
  },
  unifiedTable: {
    border: 'none',
    marginTop: theme.spacing(3),
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  stageHeaderCell: {
    backgroundColor: '#FFE8CC',
    color: '#000',
    fontWeight: 700,
    padding: theme.spacing(0.75, 1.5),
    fontSize: '0.875rem',
    border: 'none',
    textAlign: 'center',
  },
  mainHeaderRow: {
    backgroundColor: '#FFE8CC',
    '& > th': {
      color: '#000',
      fontWeight: 700,
      padding: theme.spacing(0.75, 1.5),
      border: 'none',
      fontSize: '0.875rem',
    },
  },
  subHeaderRow: {
    backgroundColor: '#FFE8CC',
    '& > th': {
      fontWeight: 700,
      padding: theme.spacing(0.75, 1.5),
      border: 'none',
      fontSize: '0.875rem',
      color: '#000',
    },
  },
  stageCell: {
    backgroundColor: 'transparent',
    color: '#222',
    fontWeight: 600,
    padding: theme.spacing(0.5, 1.5),
    verticalAlign: 'middle',
    fontSize: '0.875rem',
    border: 'none',
    borderBottom: '1px solid #E0E0E0',
    textAlign: 'center',
  },
  tableRow: {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  dataCell: {
    padding: theme.spacing(0.5, 1.5),
    borderBottom: '1px solid #E0E0E0',
    verticalAlign: 'middle',
    textAlign: 'center',
    fontSize: '0.875rem',
    color: '#333',
    backgroundColor: '#fff',
  },
  consumedCell: {
    padding: theme.spacing(0.5, 1.5),
    borderBottom: '1px solid #E0E0E0',
    verticalAlign: 'middle',
    textAlign: 'center',
    fontSize: '0.875rem',
    color: '#333',
    backgroundColor: '#fff',
  },
  materialCell: {
    padding: theme.spacing(0.5, 1.5),
    borderBottom: '1px solid #E0E0E0',
    verticalAlign: 'middle',
    textAlign: 'center',
    fontSize: '0.875rem',
    color: '#333',
    backgroundColor: '#fff',
  },
  consumedMaterialCell: {
    padding: theme.spacing(0.5, 1.5),
    borderBottom: '1px solid #E0E0E0',
    borderRight: 'none',
    verticalAlign: 'middle',
    textAlign: 'center',
    fontSize: '0.875rem',
    color: '#333',
    backgroundColor: '#fff',
  },
  cmoText: {
    color: '#ec6535',
    fontWeight: 500,
  },
  sponsorText: {
    color: '#712B5D',
    fontWeight: 500,
  },
}));


